import sheema from "./Images/sheema.png";
import nay from "./Images/nay.png";
import hikari from "./Images/hikari.png";
import nyan from "./Images/nyan.png";
import sithu from "./Images/sithu.jpg";
import william from "./Images/william.jpg";
import albert from "./Images/albert.png";
import kaung from "./Images/kaung.png";
import michelle from "./Images/michelle.png";
import angelina from "./Images/angelina.png"
import kacey from "./Images/kacey.png"
import sumay from "./Images/sumay.jpeg"
import lucas from "./Images/lucas.png"
import alfredphyo from "./Images/alfred.png"
import ingyin from "./Images/ingyin.png"

export const currentBoard = [
    {
        name: "Hikari Kyi",
        title: "President",
        img: hikari
    },
    {
        name: "Sheema Muller",
        title: "Vice President",
        img: sheema
    },
    {
        name: "Ingyin Moh",
        title: "Internal Relations",
        img: ingyin
    },
    {
        name: "Angelina Yun Yee",
        title: "External Relations",
        img: angelina
    },
    {
        name: "Nyan Aung",
        title: "Secretary",
        img: nyan
    },
    {
        name: "Kacey Zay-Ya",
        title: "Treasurer",
        img: kacey
    },
    {
        name: "Sithu Soe",
        title: "Marketing Coordinator",
        img: sithu
    },
    {
        name: "Michelle Myint",
        title: "Events Coordinator",
        img: michelle
    },
    {
        name: "Lucas Hlaing",
        title: "Accounting Coordinator",
        img: lucas
    },
    {
        name: "Alfred Phyo",
        title: "Operations Coordinator",
        img: alfredphyo,
    },
]

export const previousBoard = [
    {
        name: "Su Aye (Nay)",
        title: "Former President",
        img: nay
    },
    {
        name: "Kaung Min Khant",
        title: "Former VP Software Development",
        img: kaung
    },
    {
        name: "Su May",
        title: "Former VP Finance",
        img: sumay
    },
    {
        name: "William Hein",
        title: "Former VP Operations",
        img: william
    },
    {
        name: "Albert Aung",
        title: "Former VP Finance",
        img: albert
    },
]
